<template>
  <div class="customer-history tw-bg-slate-200 tw-border-l">
    <div
      class="tw-bg-white tw-w-full tw-h-full tw-flex tw-flex-col tw-overflow-hidden"
    >
      <div
        class="tw-mb-2 tw-border-b tw-border-gray-200 dark:tw-border-gray-700"
      >
        <ul
          class="tw-flex tw-flex-wrap tw-justify-around tw--mb-px tw-text-sm tw-font-medium tw-text-center"
        >
          <li v-for="(tab, index) in tabs" :key="tab.value" class="tw-mr-2">
            <button
              class="tw-inline-block tw-p-4 tw-rounded-t-lg"
              :class="
                currentIndex === index
                  ? 'tw-border-b-2 tw-border-slate-400'
                  : ''
              "
              @click="currentIndex = index"
              type="button"
            >
              {{ tab.label }}
            </button>
          </li>
        </ul>
      </div>
      <div class="content tw-w-full tw-h-full tw-overflow-auto tw-p-4">
        <keep-alive>
          <component
            :is="currentComponent"
            :customer="customer"
            @order-detail="onOrderDetail"
            :orderID="selectedOrder"
            @clear="selectedOrder = null"
          ></component>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CustomerHistory",
  components: {
    OrderDetail: () => import("./customer/OrderDetail.vue"),
    OrderHistory: () => import("./customer/OrderHistory.vue"),
    ChatNote: () => import("./ChatNote.vue"),
  },
  data() {
    return {
      currentIndex: 0,
      tabs: [
        {
          label: "Room",
          component: "ChatNote",
        },
        {
          label: "Customer",
          component: "OrderHistory",
        },
        {
          label: "Order Detail",
          component: "OrderDetail",
        },
      ],
      selectedOrder: null,
    };
  },
  computed: {
    ...mapGetters({
      room: "chat/room",
    }),
    customer() {
      const participants = this.room?.MainChannel?.Participants;
      return participants?.find((p) => p.Type === "customer");
    },
    currentComponent() {
      return this.tabs[this.currentIndex].component;
    },
  },
  methods: {
    onOrderDetail(orderID) {
      console.log("onRoomDetail");
      this.currentIndex = this.tabs.findIndex(
        (t) => t.component === "OrderDetail"
      );
      this.selectedOrder = orderID;
    },
  },
};
</script>

<style>

</style>
